import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import { SearchPaymentsQuery, SearchPaymentsResponse } from '../../entity/other-entities/search-payments-query';
import { Observable } from 'rxjs';
import { DateRange } from '../../../app/entity';

@Injectable()
export class PaymentsService {

    constructor(
        private http: Http,
        private httpClient: HttpClient,
        private authService: AuthService,
        private settings: SettingsService
    ) { }

    getPaymentStatistics(statisticsTypeId: number) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(
            `${this.settings.serverMain}/Payment/GetStatisticsNew?statisticsTypeId=${statisticsTypeId}`,
            { headers: headers }
        ).map((res) => res.json());
    }

    getPayments(query: SearchPaymentsQuery) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());
        const url = this.settings.serverMain + 'Payment/GetPayments';
        return this.http.post(url, query, {headers: headers}).map((res) => res.json());
    }

    exportPayments(query: SearchPaymentsQuery): Observable<Blob> {
        const headers = new HttpHeaders()
            .set('LoginRole', `${this.authService.getUserLoginRole()}`)
            .set('Authorization', this.authService.getUserToken());
        const url = this.settings.serverMain + 'Payment/ExportPayments';
        return this.httpClient.post(url, query, { headers: headers, responseType: 'blob'});
    }

    getUserPayments(id) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverNomenclator + 'Payment/GetByPortalOperator?portalOperatorId=' + id, { headers: headers })
            .map((res) => res.json());
    }

    getIncomings(typeId: number) {
        const headers = new Headers();
        headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
        headers.append('Authorization', this.authService.getUserToken());

        return this.http.get(this.settings.serverMain + 'Payment/GetIncomings?incomingsTypeId=' + typeId, { headers: headers })
            .map((res) => res.json());
    }
}

